import { all, call, put, takeLatest } from 'redux-saga/effects';
import { apiGetCall, apiPostCall } from '../api';
import {
  getAllRegistrationData,
  setAllRegistrationData
} from '../slices/sellerRegSlice';
import {
  submitRequest,
  submitSuccess,
  submitFailure
} from '../slices/sellerRegSlice';

const SELLER_REGISTRATION_URL =
  process.env.REACT_APP_SELLER_REGISTRATION_FORM_URL;

function* getAllRegistrationDataSaga() {
  try {
    const data = yield call(
      apiGetCall,
      SELLER_REGISTRATION_URL + 'registration',
      {
        headers: {
          Authorization: undefined
        }
      }
    );
    yield put(setAllRegistrationData(data));
  } catch (error: any) {
    console.log('get formdata err:', error.message);
  }
}

const updatePOS = (postData) => {
  const pos =
    postData['pos_preference'] && postData['pos_preference'].length !== 0
      ? postData['pos_preference'].map((pos) => pos.split(' ').pop())
      : [];
  const posOther =
    postData['pos_preference_other'] &&
    postData['pos_preference_other'].length !== 0
      ? postData['pos_preference_other'].map((pos) => pos.split(' ').pop())
      : [];
  const posPreference =
    pos.length || posOther.length ? [...pos, ...posOther] : ['None'];
  return {
    pos_preference: posPreference
  };
};

function* submitSellerRegistrationSaga(action: any) {
  try {
    const postData = action.payload;
    console.log('Submitting Seller Registration with data:', postData);

    const response = yield call(
      apiPostCall,
      SELLER_REGISTRATION_URL + 'register',
      postData
    );
    if (response) {
      yield put(submitSuccess());
    } else {
      yield put(submitFailure('Submission failed'));
    }
  } catch (error: any) {
    console.log('submitSellerRegistrationSaga error:', error);
    yield put(submitFailure(error));
  }
}

function* sagas() {
  yield all([
    takeLatest(getAllRegistrationData.type, getAllRegistrationDataSaga),
    takeLatest(submitRequest.type, submitSellerRegistrationSaga)
  ]);
}

export default sagas;
